import { ProgramSummaryResponse } from "../../types/program.response";

interface ProgramHeaderProps {
    program: ProgramSummaryResponse;
}

export default function ProgramHeader({ program }: ProgramHeaderProps) {
    return (
        <div className="flex items-start mb-6 px-6">
            {/* Avatar - Overlapping Banner */}
            <div className="-mt-10 mr-4 md:-mt-12 md:mr-6">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white border-4 border-white overflow-hidden flex items-center justify-center shadow-md">
                    <span className="text-3xl md:text-4xl font-bold text-gray-700 select-none">
                        {program.info.id.substring(0, 2).toUpperCase()}
                    </span>
                </div>
            </div>

            {/* Title Section */}
            <div className="mt-2 md:mt-3 flex-1">
                <h1 className="text-xl md:text-3xl font-bold text-gray-900 leading-tight">
                    {program.info.name}{program.info.type === 'minor' ? ' Minor' : ''}
                </h1>
            </div>
        </div>
    );
}